(function($) {
    $.fn.menuGrid = function(options) {
        var settings = $.extend({
            breakpoints: [
                { minWidth: 1150, columns: 4 },
                { minWidth: 900, columns: 3 },
                { minWidth: 640, columns: 2 },
                { minWidth: 0, columns: 1 }
            ],
            marginBottom: 25
        }, options);

        var $grid = this;

        function getNumColumns() {
            var width = $(window).width();
            for (var breakPoint of settings.breakpoints) {
                if (width >= breakPoint.minWidth) return breakPoint.columns;
            }
            return 1;
        }

        function updateGrid() {
            var numColumns = getNumColumns();
            if(numColumns == 1){
                $('#main-menu-container').attr('style', '');
                $grid.find('.menu-branch').each(function(i){
                    $(this).attr('style', '');
                });
            }else{
                var columnHeights = Array(numColumns).fill(0);
                $grid.find('.menu-branch').each(function(i) {
                    var column = i % numColumns;
                    $(this).css({
                        left: (column * 100 / numColumns) + '%',
                        top: columnHeights[column] + 'px'
                    });
                    columnHeights[column] += $(this).outerHeight(true) + settings.marginBottom;
                });
                $grid.css('height', Math.max(...columnHeights) + 'px');
            }
        }

        updateGrid();
        // Expose updateGrid for external calls
        $grid.data('updateGrid', updateGrid);
        $(window).on('resize', updateGrid);

        $(document).on('click', '.vk-menu-toggle', function(e) {
            e.preventDefault();
            var submenu = jQuery(this).parent().nextAll('.vk-submenu').first();
            if(submenu.hasClass('visible')){
                submenu.removeClass('visible');
                jQuery(this).attr('aria-expanded', 'false');
            }else{
                submenu.addClass('visible');
                jQuery(this).attr('aria-expanded', 'true');
            }
            updateGrid();
            return false;
        });
        return this;
    };
})(jQuery);



jQuery(function(){
    var menuInitialized = false;
    jQuery('#menu-button').attr('onclick', 'return false;');
    jQuery('#menu-button').click(function(e) {
        e.preventDefault();
        if(jQuery('#vk-main-menu').hasClass('visible')){
            jQuery('#menu-button').attr('aria-expanded', 'false');
            jQuery('#menu-button .hamburger-label').text( vkMenuData.menuText );
            jQuery('#vk-main-menu').removeClass('visible');
            jQuery('.off-canvas-content').css('min-height', '100%');
        }
        else{
            jQuery('#menu-button').attr('aria-expanded', 'true');
            jQuery('#menu-button .hamburger-label').text( vkMenuData.closeText );
            jQuery('#vk-main-menu').addClass('visible');
            if(!menuInitialized){
                jQuery('#main-menu-container').menuGrid();
                menuInitialized = true;
            } else {
                // Call updateGrid if already initialized
                var updateGridFn = jQuery('#main-menu-container').data('updateGrid');
                if (typeof updateGridFn === 'function') {
                    updateGridFn();
                }
            }
        }
        return false;
    });

    jQuery(document).on("keypress", ".vk-menu-toggle", function(e) {
        if (e.which == 13) {
            jQuery(this).click();
        }
    });
});